import { DOCUMENT } from '@angular/common';
import { Inject, NgModule } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { MojoWebsocketModule, MojoWebsocketService } from 'mojo-websocket';
import { filter, switchMap, take, map } from 'rxjs/operators';

import { AuthService } from '@core/auth';
import { websocketReducer } from '@core/websocket/store';
import { environment } from '@env/environment';

import { websocketConnected, websocketDisconnected } from './store/websocket.actions';

@NgModule({
  imports: [
    StoreModule.forFeature('websocket', websocketReducer),
    MojoWebsocketModule.forRoot({ baseUrl: environment.API_BASE_URL }),
  ],
})
export class WebsocketModule {
  constructor(
    authService: AuthService,
    webSocketService: MojoWebsocketService,
    store: Store<{}>,
    @Inject(DOCUMENT) document: Document,
  ) {
    let status = 'STOPPED';
    authService.isAuthenticated$
      .pipe(
        filter(Boolean),
        switchMap((isAuthenticated) =>
          authService.getAccessToken().pipe(
            take(1),
            map((token) => ({ isAuthenticated, token })),
          ),
        ),
      )
      .subscribe(({ isAuthenticated, token }) => {
        if (isAuthenticated) {
          if (status === 'STOPPED') {
            status = 'INIT';
            webSocketService
              .start(() => token)
              .subscribe(() => {
                status = 'READY';
                store.dispatch(websocketConnected());
              });
          } else if (status === 'READY') {
            status = 'INIT';
            store.dispatch(websocketDisconnected());
            webSocketService
              .restart(() => token)
              .subscribe(() => {
                status = 'READY';
                store.dispatch(websocketConnected());
              });
          }
        }
      });
  }
}
